<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    clipped
    width="230"
    color="dark"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <v-list
      class="vertical-nav-menu-items"
      expand
      shaped
    >
      <nav-menu-section-title title="MENU" />

      <!-- <nav-menu-link
        :icon="icons.mdiHomeOutline"
        :to="{ name: 'dashboard' }"
        title="Dashboard"
        dark
      /> -->

      <nav-menu-group
        :icon="icons.mdiFileChart"
        :title="'Relatórios'"
      >
        <nav-menu-link
          :to="{ name: 'reportService' }"
          title="Serviços"
        />
        <!-- <nav-menu-link
          :to="{ name: 'reportGraphics' }"
          title="Gráficos"
        />
        <nav-menu-link
          :to="{ name: 'reportSMS' }"
          title="Relatório SMS"
        /> -->
      </nav-menu-group>

      <nav-menu-link
        :icon="icons.mdiMessageDraw"
        :to="{ name: 'smsTemplates' }"
        title="Templates"
      />

      <nav-menu-group
        v-if="isAdmin || isAffiliate"
        :icon="icons.mdiBadgeAccount"
        :title="'Afiliados'"
      >
        <nav-menu-link
          :to="{ name: 'affiliates' }"
          title="Relatórios"
        />
        <nav-menu-link
          v-if="isAdmin"
          :to="{ name: 'affiliatesComission' }"
          title="Comissão"
        />
      </nav-menu-group>

      <nav-menu-group
        v-if="isAdmin"
        :icon="icons.mdiHeadCog"
        :title="'Moderação'"
      >
        <nav-menu-link
          v-if="isAdmin"
          :to="{ name: 'reportVoice' }"
          title="Campanha Voz"
        />

        <nav-menu-link
          v-if="isAdmin"
          :to="{ name: 'reportSmsTemplate' }"
          title="SMS Template"
        />
      </nav-menu-group>

      <nav-menu-section-title title="SERVIÇOS" />

      <nav-menu-link
        :icon="icons.mdiMessageTextOutline"
        :to="{ name: 'serviceSms' }"
        title="SMS"
      />

      <nav-menu-link
        :icon="icons.mdiCellphoneMessage"
        :to="{ name: 'serviceRcs' }"
        title="RCS"
      />

      <nav-menu-link
        :icon="icons.mdiPhonePlusOutline"
        :to="{ name: 'serviceVoice' }"
        title="Torpedo Voz"
      />

      <nav-menu-group
        :icon="icons.mdiWhatsapp"
        :title="'Whatsapp'"
      >
        <nav-menu-link
          :to="{ name: 'serviceWhatsapp' }"
          title="Campanha"
          exact
        />
        <nav-menu-link
          :to="{ name: 'serviceWhatsappChannels' }"
          title="Canais"
        />
      </nav-menu-group>

      <nav-menu-link
        v-if="!isUserHavePermission"
        :icon="icons.mdiCheckAll"
        :to="{ name: 'serviceSanitizer' }"
        title="Higienizador"
      />

      <nav-menu-link
        v-if="!isUserHavePermission"
        :icon="icons.mdiCounter"
        :to="{ name: 'serviceNumberGenerator' }"
        title="Gerador de Números"
      />

      <nav-menu-link
        :icon="icons.mdiClipboardListOutline"
        :to="{ name: 'serviceListAutomation' }"
        title="Lista"
      />

      <nav-menu-link
        :icon="icons.mdiRobot"
        :to="{ name: 'serviceAutomations' }"
        title="Automações"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiChartBar"
        :to="{ name: 'serviceVolumetry' }"
        title="Volumetria"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiAccountSearch"
        :to="{ name: 'serviceConsultaPf' }"
        title="Consulta unitária"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiDatabaseImport"
        :to="{ name: 'serviceEnriquecimento' }"
        title="Enriquecimento"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiAccountGroup"
        :to="{ name: 'serviceProspeccao' }"
        title="Prospecção"
      />

      <nav-menu-section-title
        v-if="!isAdmin"
        title="CONTA"
      />

      <nav-menu-link
        v-if="!isAdmin"
        :icon="icons.mdiPiggyBankOutline"
        :to="{ name: 'accountHirePlan' }"
        title="Inserir Saldo"
      />

      <nav-menu-link
        v-if="!isAdmin"
        :icon="icons.mdiFileDocument"
        :to="{ name: 'accountWalletExtract' }"
        title="Extrato"
      />

      <nav-menu-section-title
        v-if="isAdmin"
        title="ADMIN"
      />
      <!--  teste -->

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiViewDashboard"
        :to="{ name: 'adminDashboard' }"
        title="Dashboard"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiAccountCircleOutline"
        :to="{ name: 'adminUser' }"
        title="Usuários"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiWhatsapp"
        :to="{ name: 'adminWhatsappControl' }"
        title="Controle Whatsapp"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiCellphoneMessage"
        :to="{ name: 'adminRcsHomologation' }"
        title="Homologação RCS"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiPiggyBankOutline"
        :to="{ name: 'adminHirePlan' }"
        title="Inserir Saldo"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiAccountCash"
        :to="{ name: 'adminRechargeWhitelabel' }"
        title="Recarga Whitelabel"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiFileDocument"
        :to="{ name: 'adminTaxesWhitelabel' }"
        title="Tarifas Whitelabel"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiChartBar"
        :to="{ name: 'adminWhitelabelUsage' }"
        title="Consumo Whitelabel"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiFileDocument"
        :to="{ name: 'adminWalletExtract' }"
        title="Extrato"
      />
<!-- 
      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiStairs"
        :to="{ name: 'adminLevels' }"
        title="Níveis"
      /> -->

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiCash"
        :to="{ name: 'adminTaxes' }"
        title="Tarifas"
      />

      <nav-menu-link
        v-if="isAdmin"
        :icon="icons.mdiChartBoxOutline"
        :to="{ name: 'adminVolumetryOrcamentos' }"
        title="Orçamentos Volumetria"
      />

      
      <template v-if="isLigData">
        <nav-menu-section-title title="Suporte" />

        <nav-menu-link
          :icon="icons.mdiVideo"
          :to="{ name: 'tutorial' }"
          title="Tutoriais"
        />

        <nav-menu-link
          :icon="icons.mdiApi"
          title="Documentação"
          href="https://api.ligdata.com.br/api"
          target="_blank"
        />

        <nav-menu-link
          :icon="icons.mdiWhatsapp"
          href="https://wa.me/5518997083364"
          title="Suporte"
          target="_blank"
        />

        <nav-menu-link
          :icon="icons.mdiFrequentlyAskedQuestions"
          :to="{ name: 'faq' }"
          title="FAQ"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {
  mdiApi,
  mdiAccountCircleOutline,
  mdiAccountCash,
  mdiBadgeAccount,
  mdiCancel,
  mdiCashMultiple,
  mdiCheckAll,
  mdiCounter,
  mdiFactory,
  mdiFileDocument,
  mdiFileChart,
  mdiFilterMenuOutline,
  mdiHomeOutline,
  mdiMessageDraw,
  mdiMessageTextOutline,
  mdiPhonePlusOutline,
  mdiPiggyBankOutline,
  mdiWhatsapp,
  mdiStairs,
  mdiCash,
  mdiHeadCog,
  mdiFrequentlyAskedQuestions,
  mdiVideo,
  mdiViewDashboard,
  mdiCellphoneMessage,
  mdiClipboardListOutline,
  mdiRobot,
  mdiChartBar,
  mdiAccountSearch,
  mdiDatabaseImport,
  mdiAccountGroup,
  mdiChartBoxOutline,
} from '@mdi/js'
import { ROLE_TYPE } from '@/store/auth/mutations'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {

    const userId = Number(localStorage.getItem('id'))
    return {
      icons: {
        mdiApi,
        mdiAccountCircleOutline,
        mdiAccountCash,
        mdiCancel,
        mdiCashMultiple,
        mdiCheckAll,
        mdiCounter,
        mdiFactory,
        mdiFileDocument,
        mdiFileChart,
        mdiFilterMenuOutline,
        mdiHomeOutline,
        mdiMessageDraw,
        mdiMessageTextOutline,
        mdiPhonePlusOutline,
        mdiPiggyBankOutline,
        mdiWhatsapp,
        mdiStairs,
        mdiCash,
        mdiHeadCog,
        mdiBadgeAccount,
        mdiFrequentlyAskedQuestions,
        mdiVideo,
        mdiViewDashboard,
        mdiCellphoneMessage,
        mdiClipboardListOutline,
        mdiRobot,
        mdiChartBar,
        mdiAccountSearch,
        mdiDatabaseImport,
        mdiAccountGroup,
        mdiChartBoxOutline,
      },
      userId,
    }
  },
  computed: {
    isAdmin() {
      const role = Number(Buffer.from(localStorage.getItem('role'), 'base64'))

      return role === ROLE_TYPE.admin
    },

    isAffiliate() {
      return String(localStorage.getItem('isAffiliate')) === 'true'
    },

    isLigData() {
      return process.env.VUE_APP_EMPRESA_ID == 1
    },

    isUserHavePermission() {
      const userId = Number(localStorage.getItem('id'))
      return process.env.VUE_APP_EMPRESA_ID == 1 && (userId === 941 || userId === '941' || userId === 936 || userId === '936'  || userId === 944 || userId === '944' || userId === 947 || userId === '947' || userId === 957 || userId === '957' )
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }

  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
